(function () {
  'use strict';
  if (window.textualProductBundleLayout) {
    window.textualProductBundleLayout();
    return;
  }

  // Match the product page's two-column breakpoint. Move the existing module
  // so selections, event listeners, and cart state survive viewport changes.
  var desktop = window.matchMedia('(min-width: 992px)');
  function placeBundles() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      var mobileSlot = section.querySelector('[data-product-bundle-mobile]');
      var desktopSlot = section.querySelector('[data-product-bundle-desktop]');
      var bundle = section.querySelector('[data-recommendation-module="together"]');
      if (!mobileSlot || !desktopSlot || !bundle) return;
      var target = desktop.matches ? desktopSlot : mobileSlot;
      if (bundle.parentElement !== target) target.appendChild(bundle);
    });
  }

  window.textualProductBundleLayout = placeBundles;
  desktop.addEventListener('change', placeBundles);
  document.addEventListener('shopify:section:load', placeBundles);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBundles, {once: true});
  } else {
    placeBundles();
  }
}());
